import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Navbar from "./components/navbar.jsx";
import Footer from "./components/footer.jsx";
import SalaryAndCompanyCount from "./components/salaryandcompanycount.jsx";
import { FaBullseye, FaGlobeAsia, FaLightbulb, FaUser, FaHeart, FaStar } from "react-icons/fa";
import LogoWall from "./components/logowall.jsx";
import { mobileWidth } from "./components/constants.jsx";
import { useTranslation } from "react-i18next";
const About = () => {
  const { t, i18n } = useTranslation();

  return (
    <div dir={i18n.dir()}>
      <Navbar />
      <ImageContainer>
        {/* <Image src="/static/images/riyadh (1).jpg" alt="Riyadh" /> */}
        <MissionContent>
          {t("mission_content")}</MissionContent>
      </ImageContainer>
      <GradientDivider />
      <GradientDivider />
      <Container>
        <VisionMission>
          <Value>
            <ValueIcon><FaBullseye /></ValueIcon>
            <ValueText>
              <ValueTitle>{t("vision_title")}</ValueTitle>
              <ValueDescription>{t("vision_desc")}</ValueDescription>
            </ValueText>
          </Value>
          <Value>
            <ValueIcon><FaGlobeAsia /></ValueIcon>
            <ValueText>
              <ValueTitle>{t("mission_title")}</ValueTitle>
              <ValueDescription>{t("mission_desc")}</ValueDescription>
            </ValueText>
          </Value>
          <Value>
            <ValueIcon><FaLightbulb /></ValueIcon>
            <ValueText>
              <ValueTitle>{t("innovation_title")}</ValueTitle>
              <ValueDescription>{t("innovation_desc")}</ValueDescription>
            </ValueText>
          </Value>
          <Value>
            <ValueIcon><FaUser /></ValueIcon>
            <ValueText>
              <ValueTitle>{t("customer_title")}</ValueTitle>
              <ValueDescription>{t("customer_desc")}</ValueDescription>
            </ValueText>
          </Value>
          <Value>
            <ValueIcon><FaHeart /></ValueIcon>
            <ValueText>
              <ValueTitle>{t("passion_title")}</ValueTitle>
              <ValueDescription>{t("passion_desc")}</ValueDescription>
            </ValueText>
          </Value>
          <Value>
            <ValueIcon><FaStar /></ValueIcon>
            <ValueText>
              <ValueTitle>{t("quality_title")}</ValueTitle>
              <ValueDescription>{t("quality_desc")}</ValueDescription>
            </ValueText>
          </Value>
        </VisionMission>
      </Container>
      <Footer />
    </div>
  );
};

export default About;

const Container = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  padding: 20px;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: 40px;
  background-image: url("/static/images/riyadh (1).jpg");
  background-repeat: no-repeat;
  background-size: cover;
  padding-top:56%;
  align-content:center;
  justify-content:center;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;
const MissionContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.7);
  text-align: center;
  font-size: 1.2rem; /* Increased text size */
  @media (max-width: ${mobileWidth}){
    width:80%;
  }
`;


const GradientDivider = styled.div`
  width: 100%;
  height: 2px;
  margin-bottom: 20px;
  margin-top: 25px;

  background: linear-gradient(to right, rgb(187 108 180), rgb(227 134 68));
`;


const VisionMission = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
`;
const Value = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  transition: transform 0.3s;
  &:hover {
    transform: translateY(-5px);
  }
`;

const ValueIcon = styled.div`
  flex: 0 0 auto;
  margin-inline-end: 20px;
  color: ${Colors.darkGreen};
  font-size: 2rem;
`;

const ValueText = styled.div`
  flex: 1 1 auto;
`;

const ValueTitle = styled.h2`
  font-size: 1.2rem;
  color: ${Colors.darkGreen};
  margin-bottom: 5px;
`;

const ValueDescription = styled.p`
  font-size: 1rem;
  color: ${Colors.charcolGrey};
  line-height: 1.4;
`;
